export const addURLParameters = ({url, params} : {url: string, params: {
    [parameterName: string]: string;
}}) : string => {
    Object.entries(params).map(([parameter, value]) => {
        url = addURLParameter({
            url,
            parameter,
            value,
        })
    })
    return url;
}

export const addURLParameter = ({url, parameter, value} : {url: string, parameter: string, value: string }) : string  => {
    const [path, params] = url.split('?');
    const pars = params?.split('&') ?? [];
    const encodedParam = encodeURIComponent(parameter);
    const encodedValue = encodeURIComponent(value);
    let updated = false;
    if (pars.length > 0) {
        //update query param id exists
        for (let i = pars.length; i-- > 0;) {
            let query = pars[i].split('=')[0];
            if( query === encodedParam) {
                pars[i] = encodedParam + '=' + encodedValue;
                updated = true;
            }
        }
    }
    if(!updated)
    {
        //add query param if not exists
        pars.push(encodedParam + '=' + encodedValue);
    }
    return path + '?' + pars.join('&');
}

export const addURLParameterToWindow = ({parameter, value} : {parameter: string, value: string }) : void => {
    const newUrl = addURLParameter({
        url: window.location.toString(),
        parameter,
        value,
    });
    if(newUrl) {
        window.history.replaceState(window.history.state, null, newUrl);
    };
}
